// Auto-generated by scripts/version-bump.js. Do not edit by hand.
export const BUILD_INFO = Object.freeze({
  "major": 1,
  "minor": 24,
  "build": "2608061354",
  "version": "1.24.2608061354",
  "builtAt": "2026-08-06T13:54:36.812Z"
});
